import { Flex } from '@utilitywarehouse/hearth-react';
import clsx from 'clsx';
import { FC } from 'react';

import { useBreakpoints } from '@utils/useBreakpoints';

import './styles.scss';

export interface ImageSlideProps {
  desktopImageUrl: string;
  mobileImageUrl: string;
  alt?: string;
  className?: string;
}

const ImageSlide: FC<ImageSlideProps> = ({
  desktopImageUrl,
  mobileImageUrl,
  alt = '',
  className,
}) => {
  const { breakpointsDown } = useBreakpoints();
  const isMobile = breakpointsDown.sm;

  const imageUrl = isMobile ? mobileImageUrl : desktopImageUrl;

  return (
    <Flex
      alignItems={{ mobile: 'start', tablet: 'center' }}
      justifyContent="center"
      className={clsx('image-slide', className)}
    >
      <img src={imageUrl} alt={alt} className="image-slide__image" />
    </Flex>
  );
};

export { ImageSlide };
